import { Flame } from 'lucide-react'
import { getQuestLink, getQuestTemplateLink } from '../utils/linkUtils'
import CopyButton from './CopyButton'

export const QuestLinks = ({ userId, journeyDayId, questId, questTemplateId }: { userId: string, journeyDayId: string, questId: string, questTemplateId: string }) => {
    return (
        <div className="flex items-center gap-1">
            Q:
            <CopyButton text={questId} />
            <a href={getQuestLink(userId, journeyDayId, questId)} target="_blank" rel="noopener noreferrer" className="px-2 py-1 bg-white hover:bg-white/60 rounded transition-colors border border-gray-200">
                <Flame size={16} className="text-gray-600" />
            </a>
            T:
            <CopyButton text={questTemplateId} />
            <a href={getQuestTemplateLink(journeyDayId, questTemplateId)} target="_blank" rel="noopener noreferrer" className="px-2 py-1 bg-white hover:bg-white/60 rounded transition-colors border border-gray-200">
                <Flame size={16} className="text-gray-600" />
            </a>
        </div>
    )
}